/** Trigger browser download of a starter-kit zip blob. */
export function triggerStarterKitZipDownload(blob, filename = 'er-chat-client-starter-kit-v1.0.zip') {
  const file =
    blob instanceof Blob ? blob : new Blob([blob], { type: 'application/zip' });
  const url = window.URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
